import apiHandler from "../core/apiHandler";

const customerApi = apiHandler('customers');
export default customerApi;